import React, { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const ConsultantSection = () => {
  const sectionRefConsultants = useRef(null);

  // Animation for the heading lines
  useGSAP(() => {
    // Register GSAP plugins
    gsap.registerPlugin(ScrollTrigger);

    // GSAP scroll-triggered animation for .line elements
    gsap.from(sectionRefConsultants.current, {
      y: 100,         // Initial Y offset
      opacity: 0,     // Start with opacity 0
      duration: 1.5,    // Duration of the animation
      stagger: 0.1,   // Stagger delay between elements
      ease: "power3.out", // Easing for smoothness
      scrollTrigger: {
        trigger: "#consultant-section",  // Trigger animation when this element comes into view
        start: "top 80%",  // Start when top of the section is at 80% of viewport height
      }
    });
  }, []);

  return (
    <section id='consultant-section' className="bg-[#1d3557]">
      <div className="container w-[80%] mx-auto flex justify-between items-center">
        {/* Left Content */}
        <div className="animate-lines mb-8 mt-40 overflow-hidden w-[60%]">
          <h1 ref={sectionRefConsultants} className="text-[90px] font-bold text-white leading-[1] tracking-tighter">
            <div className="">BE A SOCRATICALI</div>
            <div className="">CONSULTANT</div>
          </h1>
          <p className="text-white text-[24px] mt-4 tracking-tight">
            Passionate about helping students achieve their dreams? Join SocraticAli as a consultant and become a guide
            for aspiring students looking to study abroad.
            <br /><br />
            Whether you're an experienced advisor or just starting, we provide the tools, training, and support you need
            to succeed.
          </p>
          <a
            href="#contact-us"
            className="bg-[#457b9d] block text-white text-[16px] text-center  max-w-[50%] font-bold px-10 py-3 rounded-md mt-10 hover:text-white transition-all duration-300"
          >
            BE A SOCRATICALI CONSULTANT
          </a>
        </div>

        {/* Right Content - Image */}
        <div className="w-1/2 p-6 rounded-lg mt-28">
          <div className="relative w-full h-screen overflow-hidden rounded-lg ml-32">
            <div className="absolute inset-0 mt-32">
              <img 
                src="/Assets/x2.png"
                className="w-[500px] h-auto" 
                alt="SocraticAli Consultant" 
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultantSection;